module.exports = __webpack_public_path__ + "media/dashboard/assets/images/instagram-a8961dbea41d2b95639d4dc8d6138686.png";